import FundingEnquiry from 'models/FundingEnquiryModel';

import { generateReducer } from 'reducers/utils/HttpReducerHelper';

import { fundingEnquiriesList } from './types';

export * from './actions';

const fundingEnquiriesListReducer = generateReducer('list', FundingEnquiry.deserialize);

const fundingEnquiriesListReducerObject = {
  [fundingEnquiriesList.request]: fundingEnquiriesListReducer.request,
  [fundingEnquiriesList.success]: fundingEnquiriesListReducer.success,
  [fundingEnquiriesList.failure]: fundingEnquiriesListReducer.failure,
};

export default fundingEnquiriesListReducerObject;
